// 获取年月日
export function getYMD (day?:string | number | Date) {
  const date = day ? new Date(day) : new Date()
  const Y = date.getFullYear()
  const M = date.getMonth() + 1
  const D = date.getDate()
  return Y + '-' + (M > 9 ? M : '0' + M) + '-' + (D > 9 ? D : '0' + D)  
}

// 获取时分秒
export function getHMS (day?:string | number | Date) {
  const date = day ? new Date(day) : new Date()
  const H = date.getHours()
  const M = date.getMinutes()
  const S = date.getSeconds()
  return (H > 9 ? H : '0' + H) + ':' + (M > 9 ? M : '0' + M) + ':' + (S > 9 ? S : '0' + S)  
}

// 获取本年开始的时间
export function getThisYearStartTime () {
  const date = new Date()
  const Y = date.getFullYear()
  return Y + '-01-01 00:00:00'
}

// 获取本月开始的时间
export function getThisMonthStartTime () {
  const date = new Date();
  const Y = date.getFullYear()
  const M = date.getMonth() + 1
  return Y + '-' + (M > 9 ? M : '0' + M) + '-01 00:00:00'
}

// 获取本周开始的时间
export function getThisWeekStartTime () {
  const date = new Date();
  const W = date.getDay() > 0 ? date.getDay() : 7 // 周几
  const target = date.getTime() - (W - 1) * 24 * 60 * 60 * 1000
  return getYMD(target) + ' 00:00:00'
}

// 获取当天开始时间
export function getTodayStartTime () {
  const date = getYMD()
  return date.replace(/\//g, '-') + ' 00:00:00'
}

// 获取当天当前时间
export function getTodayNowTime () {
  const date = getYMD()
  const time = getHMS()
  return date + ' ' + time
}

// 获取当天结束时间
export function getTodayEndTime () {
  const date = getYMD()
  return date + ' 23:59:59'
}

// 获取当天日期
export function getTodayDate () {
  const date = getYMD()
  return date
}

// 获取昨天时间
export function getYesterdayDate () {
  const day = new Date()
  day.setTime(day.getTime() - 24 * 60 * 60 * 1000)
  const yesterday = getYMD(day)
  return yesterday
}

// 获取2个日期相差天数
export function getDiffDayBetweenTwoDays (day1: string, day2: string) {
  const date1 = new Date(day1.split(' ')[0])
  const date2 = new Date(day2.split(' ')[0])
  const beginDate = date1 > date2 ? date2 : date1
  const endDate = date1 > date2 ? date1 : date2
  const diff = (endDate.getTime() - beginDate.getTime()) / (1000 * 60 * 60 * 24)
  return diff
}

// 获取2个日期之间的所有日期
export function getDateBetweenTwoDays (day1: string, day2: string) {
  const date1 = getYMD(day1)
  const date2 = getYMD(day2)
  const beginDate = date1 > date2 ? new Date(date2) : new Date(date1)
  const endDate = date1 > date2 ? new Date(date1) : new Date(date2)
  const diff = (endDate.getTime() - beginDate.getTime()) / (1000 * 60 * 60 * 24)
  const dateArr: any[] = []
  for (let i = 0; i <= diff; i++) {
    const day = getYMD(beginDate.getTime() + i * 24 * 3600 * 1000)
    dateArr.push(day.replace(/\//g, '-'))
  }
  return dateArr
}

// 时间戳转天数
export function time2Day (time) {
  const d = Math.floor(time / (24 * 60 * 60 * 1000));
  let remainder = time % (24 * 60 * 60 * 1000);
  const h = Math.floor(remainder / (60 * 60 * 1000));
  remainder = remainder % (60 * 60 * 1000)
  const m = Math.floor(remainder / (60 * 1000));
  remainder = remainder % (60 * 1000);
  const s = Math.floor(remainder / 1000);
  return [d, h, m, s];
}
